import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=db9ff454"
import script from "./LoginMain.vue?vue&type=script&lang=ts"
export * from "./LoginMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports